import { useEffect, useState } from "react"

import scrollTo from "utils/scrollTo"

export const usePicture = ({isEnvironmentCamera, videoRef, format, outputType, onTakePicture, _closeStreamTracks, handleReopenCamera }) => {
	const [ pictureData, setPictureData ] = useState({})
	const [ imagePath, setImagePath ] = useState(null)
  	const [ shouldOpenPictureReview, setShouldOpenPictureReview ] = useState(false)

	useEffect(() => {
		if (!!pictureData) {
			setImagePath(
				pictureData.path ||
				(pictureData.blob ? URL.createObjectURL(pictureData?.blob) : null)
			)
		}
	}, [ pictureData ])

	function handleTakePicture() {
		const currentVideo = videoRef.current
		const virtualCanvas = document.createElement("canvas")
		virtualCanvas.height = currentVideo.videoHeight
		virtualCanvas.width = currentVideo.videoWidth
		const canvasContext = virtualCanvas.getContext("2d")
	
		if (!isEnvironmentCamera) {
		  canvasContext.translate(virtualCanvas.width, 0)
		  canvasContext.scale(-1, 1)
		}
		
		canvasContext.drawImage(currentVideo, 0, 0)
		const outputFormat = `image/${format}`
	
		virtualCanvas.toBlob(
		  (blob) => {
			setPictureData({
			  path: virtualCanvas.toDataURL(outputFormat),
			  blob,
			})
		  },
		  outputFormat,
		  1
		)
		console.log('[ CAMERA ] The photo was taken.')
		setShouldOpenPictureReview(true)
		_closeStreamTracks()
	  }

	
	function handleTakeOtherPhoto() {
		console.log('[ CAMERA ] User will take another photo')
		
		setShouldOpenPictureReview(false)
		setPictureData({})
		handleReopenCamera()
	}

	function handleUseThisPhoto() {
		console.log('[ CAMERA ] User will use this photo')
		const picturePath = outputType === "dataURL" ? pictureData.path : pictureData.blob
		onTakePicture(picturePath)

		setShouldOpenPictureReview(true)
		scrollTo(0)
	}

	return {
		imagePath,
		shouldOpenPictureReview,
		handleTakePicture,
		handleTakeOtherPhoto,
		handleUseThisPhoto
	}
}